/**
 * Avalara © 2017
 * file: engines/opus_ui/src/containers/SearchContainer.js
 */

import React, { Component } from 'react';
import './SearchContainer.css';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { fetchSearchResultsIfNeeded } from '../actions/search';
import GeneralSearchBar from '../search/GeneralSearchBar';
import ResultsFacetBar from '../search/ResultsFacetBar';
import ResultsArea from '../search/ResultsArea';
import loading from '../assets/loading.gif';
import { withRouter } from './WithRouter';

class SearchContainer extends Component {
  componentDidMount() {
    this.resolveDataDependencies(this.props);
  }

  componentWillUpdate(nextProps) {
    this.resolveDataDependencies(nextProps);
  }

  resolveDataDependencies(props) {
    const { dispatch } = props;
    const queryObj = queryString.parse(props.router.location.search);
    const query = queryObj?.query;
    const caseId = queryObj?.case;
    dispatch(fetchSearchResultsIfNeeded(query, caseId));
  }

  render() {
    let {
      rankedSearchResults,
      isFetching,
      requestTotalTime,
      searchSystems,
      searchSystemsFailure,
      searchSystemsSuccess
    } = this.props.search;
    const query = queryString.parse(this.props.router.location.search) || '';
    const facet = query;
    const caseId = query?.case;
    const queryParams = { query: query?.query, caseId };
    const { dispatch } = this.props;
    const {
      isCaseUpdating,
      caseRequestStatus,
      isCancellationPending
    } = this.props.cases;

    if (!searchSystems) {
      searchSystems = [];
    }

    return (
      <div className="SearchContainer">
        <div className="SearchBarArea">
          <GeneralSearchBar query={query?.query} />
          <ResultsFacetBar facet={facet} />
        </div>
        <div className="LoadingTagList">
          {searchSystems
            .filter(
              s =>
                !searchSystemsSuccess.includes(s) &&
                !searchSystemsFailure.includes(s)
            )
            .map((s, index) => (
              <div className="LoadingTag" key={index}>
                <span className="LoadingLabel">{`${s} is loading...`}</span>
                <img src={loading} alt="" className="LoadingImg" />
                <br />
              </div>
            ))}
        </div>
        <ResultsArea
          dispatch={dispatch}
          queryParams={queryParams}
          searchResults={rankedSearchResults}
          isFetching={isFetching}
          requestTotalTime={requestTotalTime}
          isCaseUpdating={isCaseUpdating}
          caseRequestStatus={caseRequestStatus}
          isCancellationPending={isCancellationPending}
        />
      </div>
    );
  }
}

function mapStateToProps({ search, cases }) {
  return { search, cases };
}

export default connect(mapStateToProps)(withRouter(SearchContainer));
